import { useMutation, useQueryClient, useSuspenseQueries } from '@tanstack/react-query';
import { offers } from '@ooh/contracts';
import type { UpdateOfferShares } from '@ooh/contracts';
import { apiQueryKey, apiQueryOptions } from '../../data/use-api-suspense-query';
import { useApiClient } from '../../plugs/api-client';

export function useOfferSharingData(offerId: string) {
  const api = useApiClient();
  const request = { id: Number(offerId) };
  const [shares, shareableUsers, shareableRoles] = useSuspenseQueries({
    queries: [
      apiQueryOptions(api, offers.listShares, request),
      apiQueryOptions(api, offers.listShareableUsers, request),
      apiQueryOptions(api, offers.listShareableRoles, request),
    ],
  });
  return {
    shares: shares.data,
    shareableUsers: shareableUsers.data,
    shareableRoles: shareableRoles.data,
  };
}

export function useUpdateOfferShares(offerId: string) {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateOfferShares) =>
      api.call(offers.updateShares, { id: Number(offerId), ...body }),
    onSuccess: (saved) => {
      queryClient.setQueryData(apiQueryKey(offers.listShares, { id: Number(offerId) }), saved);
    },
  });
}
